export default __webpack_public_path__ + "static/signature-m2-29f9afd1d2105b79b7198b28cf6ba1ec.png";